/* unplugin-vue-components disabled */const { ref, computed, onBeforeMount } = require('vue');
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = n => ((0, vue_2.pushScopeId)("data-v-e293c878"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = { class: "left-bar" };
const _hoisted_2 = _withScopeId(() => (0, vue_2.createElementVNode)("div", { class: "logo" }, [
    (0, vue_2.createElementVNode)("div", { class: "image" })
], -1));
const _hoisted_3 = { class: "enum-item el-menu-tooltip__trigger" };
const _hoisted_4 = _withScopeId(() => (0, vue_2.createElementVNode)("span", null, "规划", -1));
const _hoisted_5 = { class: "enum-item el-menu-tooltip__trigger" };
const _hoisted_6 = _withScopeId(() => (0, vue_2.createElementVNode)("span", null, "编程", -1));
const _hoisted_7 = { class: "enum-item el-menu-tooltip__trigger" };
const _hoisted_8 = _withScopeId(() => (0, vue_2.createElementVNode)("span", null, "仿真", -1));
const _hoisted_9 = { class: "enum-item el-menu-tooltip__trigger" };
const _hoisted_10 = _withScopeId(() => (0, vue_2.createElementVNode)("span", null, "配置", -1));
const _hoisted_11 = _withScopeId(() => (0, vue_2.createElementVNode)("div", { style: { "position": "absolute", "bottom": "0" } }, [
    (0, vue_2.createElementVNode)("div", { class: "logo" }, [
        (0, vue_2.createElementVNode)("div", { class: "head" })
    ])
], -1));
const one_message_1 = require("@/utils/one_message");
const user_1 = require("@/service/user");
const router_1 = tslib_1.__importDefault(require("@/router"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'LeftBar',
    emits: ['openProject', 'handleSelect'],
    setup(__props, { emit: __emit }) {
        const userInfo = ref();
        const emit = __emit;
        const curPage = computed(() => router_1.default.currentRoute.value.name);
        const activeIndex = computed(() => {
            if (curPage.value == "design") {
                return 1;
            }
            else if (curPage.value === "program") {
                return 2;
            }
            else if (curPage.value === "laborer") {
                return 4;
            }
        });
        const isCollapse = ref(true);
        function handleOpen(key, keyPath) {
            console.log(key, keyPath);
        }
        function handleClose(key, keyPath) {
            console.log(key, keyPath);
        }
        function handleSelect(key, keyPath) {
            if (key == 0) {
                emit('openProject');
                return;
            }
            else if (key == 1) {
                emit('handleSelect', 'design');
            }
            else if (key == 2) {
                emit('handleSelect', 'program');
            }
            else if (key == 4) {
                emit('handleSelect', 'laborer');
            }
        }
        let clkCount = 0;
        function onLogoClick() {
            clkCount++;
            if (clkCount === 6) {
                (0, one_message_1.oneMessage)(location.host);
                clkCount = 0;
            }
        }
        onBeforeMount(() => tslib_1.__awaiter(this, void 0, void 0, function* () {
            userInfo.value = yield (0, user_1.getUserInfo)();
            console.log('userInfo.value', userInfo.value);
        }));
        return (_ctx, _cache) => {
            const _component_svg_icon = (0, vue_2.resolveComponent)("svg-icon");
            const _component_el_icon = (0, vue_2.resolveComponent)("el-icon");
            const _component_el_menu_item = (0, vue_2.resolveComponent)("el-menu-item");
            const _component_el_menu = (0, vue_2.resolveComponent)("el-menu");
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createVNode)(_component_el_menu, {
                    "default-active": (0, vue_2.unref)(activeIndex),
                    class: "el-menu-vertical",
                    collapse: (0, vue_2.unref)(isCollapse),
                    onOpen: handleOpen,
                    onClose: handleClose,
                    onSelect: handleSelect
                }, {
                    default: (0, vue_2.withCtx)(() => {
                        var _a, _b, _c;
                        return [
                            _hoisted_2,
                            (0, vue_2.createVNode)(_component_el_menu_item, {
                                index: "1",
                                disabled: !(((_a = (0, vue_2.unref)(userInfo)) === null || _a === void 0 ? void 0 : _a.perms) || []).includes('app:ide:page:design'),
                                class: (0, vue_2.normalizeClass)((0, vue_2.unref)(activeIndex) == 1 ? 'menu-select' : '')
                            }, {
                                default: (0, vue_2.withCtx)(() => [
                                    (0, vue_2.createElementVNode)("div", _hoisted_3, [
                                        (0, vue_2.createVNode)(_component_el_icon, { class: "icon-item" }, {
                                            default: (0, vue_2.withCtx)(() => [
                                                (0, vue_2.createVNode)(_component_svg_icon, {
                                                    class: "icon",
                                                    "icon-class": "model"
                                                })
                                            ]),
                                            _: 1
                                        }),
                                        _hoisted_4
                                    ])
                                ]),
                                _: 1
                            }, 8, ["disabled", "class"]),
                            (0, vue_2.createVNode)(_component_el_menu_item, {
                                index: "2",
                                disabled: !(((_b = (0, vue_2.unref)(userInfo)) === null || _b === void 0 ? void 0 : _b.perms) || []).includes('app:ide:page:program'),
                                class: (0, vue_2.normalizeClass)((0, vue_2.unref)(activeIndex) == 2 ? 'menu-select' : '')
                            }, {
                                default: (0, vue_2.withCtx)(() => [
                                    (0, vue_2.createElementVNode)("div", _hoisted_5, [
                                        (0, vue_2.createVNode)(_component_el_icon, { class: "icon-item" }, {
                                            default: (0, vue_2.withCtx)(() => [
                                                (0, vue_2.createVNode)(_component_svg_icon, {
                                                    class: "icon",
                                                    "icon-class": "block"
                                                })
                                            ]),
                                            _: 1
                                        }),
                                        _hoisted_6
                                    ])
                                ]),
                                _: 1
                            }, 8, ["disabled", "class"]),
                            (0, vue_2.createVNode)(_component_el_menu_item, {
                                disabled: "",
                                index: "3",
                                class: (0, vue_2.normalizeClass)((0, vue_2.unref)(activeIndex) == 3 ? 'menu-select' : '')
                            }, {
                                default: (0, vue_2.withCtx)(() => [
                                    (0, vue_2.createElementVNode)("div", _hoisted_7, [
                                        (0, vue_2.createVNode)(_component_el_icon, { class: "icon-item" }, {
                                            default: (0, vue_2.withCtx)(() => [
                                                (0, vue_2.createVNode)(_component_svg_icon, {
                                                    class: "icon",
                                                    "icon-class": "robot"
                                                })
                                            ]),
                                            _: 1
                                        }),
                                        _hoisted_8
                                    ])
                                ]),
                                _: 1
                            }, 8, ["class"]),
                            (0, vue_2.createVNode)(_component_el_menu_item, {
                                index: "4",
                                disabled: !(((_c = (0, vue_2.unref)(userInfo)) === null || _c === void 0 ? void 0 : _c.perms) || []).includes('app:ide:page:laborer'),
                                class: (0, vue_2.normalizeClass)((0, vue_2.unref)(activeIndex) == 4 ? 'menu-select' : '')
                            }, {
                                default: (0, vue_2.withCtx)(() => [
                                    (0, vue_2.createElementVNode)("div", _hoisted_9, [
                                        (0, vue_2.createVNode)(_component_el_icon, { class: "icon-item" }, {
                                            default: (0, vue_2.withCtx)(() => [
                                                (0, vue_2.createVNode)(_component_svg_icon, {
                                                    class: "icon",
                                                    "icon-class": "impl"
                                                })
                                            ]),
                                            _: 1
                                        }),
                                        _hoisted_10
                                    ])
                                ]),
                                _: 1
                            }, 8, ["disabled", "class"]),
                            _hoisted_11
                        ];
                    }),
                    _: 1
                }, 8, ["default-active", "collapse"]),
                (0, vue_2.createElementVNode)("div", {
                    onClick: onLogoClick,
                    class: "info-btn"
                })
            ]));
        };
    }
});
